import React, { createContext } from "react";
import surveyAdapter from "common/Adapters/SurveyAdapter/Router";
import { useCollectionData } from "../pages/SurveyPage/useCollectionData";

export const DataCollectionContext = createContext(null);

// eslint-disable-next-line react/prop-types
export function DataCollectionProvider({ children }) {
  const collection = useCollectionData({ surveyAdapter });

  return <DataCollectionContext.Provider value={collection}>{children}</DataCollectionContext.Provider>;
}
